module.exports = __webpack_public_path__ + "static/media/chat.017217eb.png";